import React from 'react';

class StoreContact extends React.Component {

    getFormattedHours(hours) {
        if (!hours) return null;
        var formattedHours = {}
        for (var i = 0; i < Object.keys(hours).length; i++) {
            if (hours[i].length === 0) {
                formattedHours[i] = ["Closed"];
            } else {
                var temp = []
                for (var j = 0; j < hours[i].length; j++) {
                    var hour = Math.floor(hours[i][j]);
                    var timeoday = "AM"
                    if (hour > 12) {
                        hour = hour - 12;
                        timeoday = "PM"
                    } 
                    var curr = hour + ":" + (hours[i][j]%1)*60 + ((hours[i][j]%1)*60 < 10 ? "0" : "") + " " + timeoday;
                    if (j%2 === 0) {
                        temp.push(curr);
                    } else {
                        temp[Math.floor(j/2)] = temp[Math.floor(j/2)] + " - " + curr;
                    }
                }
                formattedHours[i] = temp;   
            }
            
        }
        return formattedHours;
    }

    formatPhoneNumber(phone) {
        phone = phone.toString();
        if (phone.length >= 4 && phone[3] !== "-") {
            phone = phone.substring(0, 3) + "-" + phone.substring(3);
        }
        if (phone.length >= 8 && phone[7] !== "-") {
            phone = phone.substring(0, 7) + "-" + phone.substring(7);
        }
        return phone;
    }

    render() {
        var { name, address, phone, logo, hours } = this.props;
        var days = ["S", "M", "T", "W", "T", "F", "S"];
        var formattedHours = this.getFormattedHours(hours);
        var formattedPhone = this.formatPhoneNumber(phone)
        return(
            <div className="contact-box">
                {logo && <img className="img-med" src={logo} alt={name + " logo"}/> }
                <div className="contact-spacing"> {name} </div>
                <div className="contact-spacing"> {address} </div>
                <div className="contact-spacing"> {formattedPhone} </div>
                { hours && <div className="contact-spacing table-align"> 
                    <table><tbody>
                    {Object.keys(formattedHours).map((key) => {
                        return (
                            <React.Fragment key={"hours-" + key}>
                                {formattedHours[key].map((val, idx) => 
                                    <tr key={"hours-" + key + "-" + idx}> 
                                        <td> {idx === 0 ? days[key] + "" : ""} </td>
                                        <td> {val} </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        )
                    })}
                    </tbody></table>
                </div>}
            </div>
        );
    }
}

export default StoreContact;